module.exports = __webpack_public_path__ + "static/media/squared.907bdfd0.jpg";